/* Copyright(c) 2016, iovation, inc. All rights reserved. */
window.io_global_object_name = 'IGLOO';
window.IGLOO = window.IGLOO || {
  install_flash: false,
  enable_flash: false,
  loader: {
    version: '5.0.0',
    fp_static: false
  }
};
